import axios from '../axios';


/**
 * z转让方式
 * 
 * @url /ent_product_good/transfer_way
 * 
 */

export function entproductgoodtransferway(params) {
    return axios.post('/ent_achievements/transfer_way', params)
}
/**
 * 行业
 * 
 * @url /ent_product_good/industry
 * 
 */

export function entproductgoodindustry(params) {
    return axios.post('/ent_achievements/industry', params)
}
// /**
//  * 分页获取成果出售
//  * 
//  * @url /ent_product_good/index
//  * 
//  */

// export function productindex(params) {
//     return axios.post('/ent_product_good/index', params)
// }
/**
 * 分页获取成果出售
 * 
 * @url /ent_achievements/on_sale
 * 
 */

export function entachievementsonsale(params) {
    return axios.post('/ent_achievements/on_sale', params)
}


/**
 * 分页获取我的出售
 * 
 * @url /ent_product_good/my
 * 
 */

export function productmy(params) {
    return axios.post('/ent_product_good/my', params)
}
// /**
//  * 新增出售
//  * 
//  * @url /ent_product_good/save
//  * 
//  */

// export function productsave(params) {
//     return axios.post('/ent_product_good/save', params)
// }
/**
 * 修改出售
 * 
 * @url /ent_product_good/update
 * 
 */

export function productupdate(params) {
    return axios.post('/ent_product_good/update', params)
}
/**
 * 删除出售
 * 
 * @url /ent_product_good/delete
 * 
 */

export function productdelete(params) {
    return axios.post('/ent_product_good/delete', params)
}
/**
 * 出售详情
 * 
 * @url /ent_product_good/detail
 * 
 */

export function productdetail(params) {
    return axios.post('/ent_product_good/detail', params)
}
/**
 * 发起购买需求
 * 
 * @url /ent_product_good/get
 * 
 */

export function entproductgoodget(params) {
    return axios.post('/ent_product_good/get', params)
}
/**
 * 发起出售需求
 * 
 * @url /ent_product_purchase/get
 * 
 */

export function entproductpurchaseget(params) {
    return axios.post('/ent_product_purchase/get', params)
}

/**
 * 分页获取我的采购
 * 
 * @url /ent_product_purchase/my
 * 
 */

export function productpurchasemy(params) {
    return axios.post('/ent_product_purchase/my', params)
}
/**
 * 分页获取成果采购
 * 
 * @url /ent_product_purchase/index
 * 
 */

export function productpurchaseindex(params) {
    return axios.post('/ent_product_purchase/index', params)
}
/**
 * 新增采购
 * 
 * @url /ent_product_purchase/save
 * 
 */

export function productpurchasesave(params) {
    return axios.post('/ent_product_purchase/save', params)
}
/**
 * 修改采购
 * 
 * @url /ent_product_purchase/update
 * 
 */

export function productpurchaseupdate(params) {
    return axios.post('/ent_product_purchase/update', params)
}
/**
 * 删除采购
 * 
 * @url /ent_product_purchase/delete
 * 
 */

export function productpurchasedelete(params) {
    return axios.post('/ent_product_purchase/delete', params)
}
/**
 * 采购详情
 * 
 * @url /ent_product_purchase/detail
 * 
 */

export function purchasedetail(params) {
    return axios.post('/ent_product_purchase/detail', params)
}
/**
 * 成果分类
 * 
 * @url /ent_product_good/cate
 * 
 */

export function productcate(params) {
    return axios.post('/ent_product_good/cate', params)
}
/**
 * 按分类采集企业数据
 * 
 * @url /company/pick_data
 * 
 */

export function companydata(params) {
    return axios.post('/company/pick_data', params)
}
/**
 * 保存企业数据
 * 
 * @url /company/pick_data_save
 * 
 */

export function companysave(params) {
    return axios.post('/company/pick_data_save', params)
}
/**
 * 企业数据分类
 * 
 * @url /company/pick_cate
 * 
 */

export function companycate(params) {
    return axios.post('/company/pick_cate', params)
}
/**
 * 分页获取投资项目
 * 
 * @url /ent_invest/index
 * 
 */

export function entinvestindex(params) {
    return axios.post('/ent_invest/index', params)
}
/**
 * 新增投资项目
 * 
 * @url /ent_invest/save
 * 
 */

export function entinvestsave(params) {
    return axios.post('/ent_invest/save', params)
}

/**
 * 投资项目详情
 * 
 * @url /ent_invest/detail
 * 
 */

export function entinvestdetail(params) {
    return axios.post('/ent_invest/detail', params)
}
/**
 * 投资项目修改
 * 
 * @url /ent_invest/update
 * 
 */

export function entinvestupdate(params) {
    return axios.post('/ent_invest/update', params)
}
/**
 * 投资项目删除
 * 
 * @url /ent_invest/delete
 * 
 */

export function entinvestdelete(params) {
    return axios.post('/ent_invest/delete', params)
}


/**
 * 分页获取企业营收与研发投入
 * 
 * @url /ent_benefits/index
 * 
 */

export function entbenefitsindex(params) {
    return axios.post('/ent_benefits/index', params)
}
/**
 * 新增企业营收与研发投入
 * 
 * @url /ent_benefits/save
 * 
 */

export function entbenefitssave(params) {
    return axios.post('/ent_benefits/save', params)
}

/**
 * 企业营收与研发投入详情
 * 
 * @url /ent_benefits/detail
 * 
 */

export function entbenefitsdetail(params) {
    return axios.post('/ent_benefits/detail', params)
}
/**
 * 企业营收与研发投入修改
 * 
 * @url /ent_benefits/update
 * 
 */

export function entbenefitsupdate(params) {
    return axios.post('/ent_benefits/update', params)
}
/**
 * 企业营收与研发投入删除
 * 
 * @url /ent_benefits/delete
 * 
 */

export function entbenefitsdelete(params) {
    return axios.post('/ent_benefits/delete', params)
}

/**
 * 分页获取承接重大项目管理
 * 
 * @url /ent_major_tech_project/index
 * 
 */

export function entmajortechprojectindex(params) {
    return axios.post('/ent_major_tech_project/index', params)
}
/**
 * 新增承接重大项目管理
 * 
 * @url /ent_major_tech_project/save
 * 
 */

export function entmajortechprojectsave(params) {
    return axios.post('/ent_major_tech_project/save', params)
}

/**
 * 承接重大项目管理详情
 * 
 * @url /ent_major_tech_project/detail
 * 
 */

export function entmajortechprojectdetail(params) {
    return axios.post('/ent_major_tech_project/detail', params)
}
/**
 * 承接重大项目管理修改
 * 
 * @url /ent_major_tech_project/update
 * 
 */

export function entmajortechprojectupdate(params) {
    return axios.post('/ent_major_tech_project/update', params)
}
/**
 * 承接重大项目管理删除
 * 
 * @url /ent_major_tech_project/delete
 * 
 */

export function entmajortechprojectdelete(params) {
    return axios.post('/ent_major_tech_project/delete', params)
}

/**
 * 分页获取研发领域管理
 * 
 * @url /ent_research_area/index
 * 
 */

export function entresearchareaindex(params) {
    return axios.post('/ent_research_area/index', params)
}
/**
 * 新增研发领域管理
 * 
 * @url /ent_research_area/save
 * 
 */

export function entresearchareasave(params) {
    return axios.post('/ent_research_area/save', params)
}

/**
 * 研发领域管理详情
 * 
 * @url /ent_research_area/detail
 * 
 */

export function entresearchareadetail(params) {
    return axios.post('/ent_research_area/detail', params)
}
/**
 * 研发领域管理修改
 * 
 * @url /ent_research_area/update
 * 
 */

export function entresearchareaupdate(params) {
    return axios.post('/ent_research_area/update', params)
}
/**
 * 研发领域管理删除
 * 
 * @url /ent_research_area/delete
 * 
 */

export function entresearchareadelete(params) {
    return axios.post('/ent_research_area/delete', params)
}

/**
 * 分页获取合作院校管理
 * 
 * @url /ent_partner_schools/index
 * 
 */

export function entpartnerschoolsindex(params) {
    return axios.post('/ent_partner_schools/index', params)
}
/**
 * 新增合作院校管理
 * 
 * @url /ent_partner_schools/save
 * 
 */

export function entpartnerschoolssave(params) {
    return axios.post('/ent_partner_schools/save', params)
}

/**
 * 合作院校管理详情
 * 
 * @url /ent_partner_schools/detail
 * 
 */

export function entpartnerschoolsdetail(params) {
    return axios.post('/ent_partner_schools/detail', params)
}
/**
 * 合作院校管理修改
 * 
 * @url /ent_partner_schools/update
 * 
 */

export function entpartnerschoolsupdate(params) {
    return axios.post('/ent_partner_schools/update', params)
}
/**
 * 合作院校管理删除
 * 
 * @url /ent_partner_schools/delete
 * 
 */

export function entpartnerschoolsdelete(params) {
    return axios.post('/ent_partner_schools/delete', params)
}
/**
 * 分页获取技改项目管理
 * 
 * @url /ent_tech_upgrade/index
 * 
 */

export function enttechupgradeindex(params) {
    return axios.post('/ent_tech_upgrade/index', params)
}
/**
 * 新增技改项目管理
 * 
 * @url /ent_tech_upgrade/save
 * 
 */

export function enttechupgradesave(params) {
    return axios.post('/ent_tech_upgrade/save', params)
}

/**
 * 技改项目管理详情
 * 
 * @url /ent_tech_upgrade/detail
 * 
 */

export function enttechupgradedetail(params) {
    return axios.post('/ent_tech_upgrade/detail', params)
}
/**
 * 技改项目管理修改
 * 
 * @url /ent_tech_upgrade/update
 * 
 */

export function enttechupgradeupdate(params) {
    return axios.post('/ent_tech_upgrade/update', params)
}
/**
 * 技改项目管理删除
 * 
 * @url /ent_tech_upgrade/delete
 * 
 */

export function enttechupgradedelete(params) {
    return axios.post('/ent_tech_upgrade/delete', params)
}


/**
 * 分页获取设备资产管理
 * 
 * @url /ent_fixed_assets/index
 * 
 */

export function entfixedassetsindex(params) {
    return axios.post('/ent_fixed_assets/index', params)
}
/**
 * 新增设备资产管理
 * 
 * @url /ent_fixed_assets/save
 * 
 */

export function entfixedassetssave(params) {
    return axios.post('/ent_fixed_assets/save', params)
}

/**
 * 设备资产管理详情
 * 
 * @url /ent_fixed_assets/detail
 * 
 */

export function entfixedassetsdetail(params) {
    return axios.post('/ent_fixed_assets/detail', params)
}
/**
 * 设备资产管理修改
 * 
 * @url /ent_fixed_assets/update
 * 
 */

export function entfixedassetsupdate(params) {
    return axios.post('/ent_fixed_assets/update', params)
}
/**
 * 设备资产管理删除
 * 
 * @url /ent_fixed_assets/delete
 * 
 */

export function entfixedassetsdelete(params) {
    return axios.post('/ent_fixed_assets/delete', params)
}

/**
 * 分页参编标准文书管理
 *
 * @url /ent_standard_author/index
 *
 */

export function entstandardauthorindex(params) {
    return axios.post('/ent_standard_author/index', params)
}
/**
 * 新增参编标准文书管理
 *
 * @url /ent_standard_author/save
 *
 */

export function entstandardauthorsave(params) {
    return axios.post('/ent_standard_author/save', params)
}

/**
 * 参编标准文书管理详情
 *
 * @url /ent_standard_author/detail
 *
 */

export function entstandardauthordetail(params) {
    return axios.post('/ent_standard_author/detail', params)
}
/**
 * 参编标准文书管理修改
 *
 * @url /ent_standard_author/update
 *
 */

export function entstandardauthorupdate(params) {
    return axios.post('/ent_standard_author/update', params)
}
/**
 * 参编标准文书管理删除
 *
 * @url /ent_standard_author/delete
 *
 */

export function entstandardauthordelete(params) {
    return axios.post('/ent_standard_author/delete', params)
}

/**
 * 分页获取资质管理
 *
 * @url /ent_qualification/index
 *
 */

export function entqualificationindex(params) {
    return axios.post('/ent_qualification/index', params)
}
/**
 * 新增资质管理
 *
 * @url /ent_qualification/save
 *
 */

export function entqualificationsave(params) {
    return axios.post('/ent_qualification/save', params)
}

/**
 * 资质管理详情
 *
 * @url /ent_qualification/detail
 *
 */

export function entqualificationdetail(params) {
    return axios.post('/ent_qualification/detail', params)
}
/**
 * 资质管理修改
 *
 * @url /ent_qualification/update
 *
 */

export function entqualificationupdate(params) {
    return axios.post('/ent_qualification/update', params)
}
/**
 * 资质管理删除
 *
 * @url /ent_qualification/delete
 *
 */

export function entqualificationdelete(params) {
    return axios.post('/ent_qualification/delete', params)
}

/**
 * 分页获取信息化软件管理
 *
 * @url /ent_software/index
 *
 */

export function entsoftwareindex(params) {
    return axios.post('/ent_software/index', params)
}
/**
 * 新增信息化软件管理
 *
 * @url /ent_software/save
 *
 */

export function entsoftwaresave(params) {
    return axios.post('/ent_software/save', params)
}

/**
 * 信息化软件管理详情
 *
 * @url /ent_software/detail
 *
 */

export function entsoftwaredetail(params) {
    return axios.post('/ent_software/detail', params)
}
/**
 * 信息化软件管理修改
 *
 * @url /ent_software/update
 *
 */

export function entsoftwareupdate(params) {
    return axios.post('/ent_software/update', params)
}
/**
 * 信息化软件管理删除
 *
 * @url /ent_software/delete
 *
 */

export function entsoftwaredelete(params) {
    return axios.post('/ent_software/delete', params)
}

/**
 * 分页获取荣誉管理
 *
 * @url /ent_honor/index
 *
 */

export function enthonorindex(params) {
    return axios.post('/ent_honor/index', params)
}
/**
 * 新增荣誉管理
 *
 * @url /ent_honor/save
 *
 */

export function enthonorsave(params) {
    return axios.post('/ent_honor/save', params)
}

/**
 * 荣誉管理详情
 *
 * @url /ent_honor/detail
 *
 */

export function enthonordetail(params) {
    return axios.post('/ent_honor/detail', params)
}
/**
 * 荣誉管理修改
 *
 * @url /ent_honor/update
 *
 */

export function enthonorupdate(params) {
    return axios.post('/ent_honor/update', params)
}
/**
 * 荣誉管理删除
 *
 * @url /ent_honor/delete
 *
 */

export function enthonordelete(params) {
    return axios.post('/ent_honor/delete', params)
}

/**
 * 分页获取融资/贷款管理
 *
 * @url /ent_finance/index
 *
 */

export function entfinanceindex(params) {
    return axios.post('/ent_finance/index', params)
}
/**
 * 新增融资/贷款管理
 *
 * @url /ent_finance/save
 *
 */

export function entfinancesave(params) {
    return axios.post('/ent_finance/save', params)
}

/**
 * 融资/贷款管理详情
 *
 * @url /ent_finance/detail
 *
 */

export function entfinancedetail(params) {
    return axios.post('/ent_finance/detail', params)
}
/**
 * 融资/贷款管理修改
 *
 * @url /ent_finance/update
 *
 */

export function entfinanceupdate(params) {
    return axios.post('/ent_finance/update', params)
}
/**
 * 融资/贷款管理删除
 *
 * @url /ent_finance/delete
 *
 */

export function entfinancedelete(params) {
    return axios.post('/ent_finance/delete', params)
}

/**
 * 获取行业分类
 *
 * @url /company/industry
 *
 */

export function companyindustry(params) {
    return axios.post('/company/industry', params)
}
/**
 * 获取企业基础资料
 *
 * @url /company/get
 *
 */

export function companyget(params) {
    return axios.post('/company/get', params)
}
/**
 * 获取园区列表
 *
 * @url /company/zone
 *
 */

export function companyzone(params) {
    return axios.post('/company/zone', params)
}
/**
 * 获取地址数据
 *
 * @url /region
 *
 */

export function companyregion(params) {
    return axios.post('/region', params)
}
/**
 * 更新企业基础资料
 *
 * @url /company/refresh
 *
 */

export function companyrefresh(params) {
    return axios.post('/company/refresh', params)
}

// 成果价值评估列表
/**
 * 成果价值评估列表
 *
 * @url /ent_assessment/index
 *
 */

export function entassessmentindex(params) {
    return axios.post('/ent_assessment/index', params)
}
/**
 * 成果价值评估列表详
 *
 * @url /ent_assessment/detail
 *
 */

export function entassessmentdetail(params) {
    return axios.post('/ent_assessment/detail', params)
}
/**
 * 成果价值评估列表增
 *
 * @url /ent_assessment/save
 *
 */

export function entassessmentsave(params) {
    return axios.post('/ent_assessment/save', params)
}
/**
 * 成果价值评估列表删
 *
 * @url /ent_assessment/delete
 *
 */

export function entassessmentdelete(params) {
    return axios.post('/ent_assessment/delete', params)
}
/**
 * 成果价值评估列表改
 *
 * @url /ent_assessment/update
 *
 */

export function entassessmentupdate(params) {
    return axios.post('/ent_assessment/update', params)
}
/**
 * 成果价值评估and成果出售委托
 *
 * @url /ent_achievements/entrust
 *
 */

export function entachievementsentrust(params) {
    return axios.post('/ent_achievements/entrust', params)
}


/**
 * 成果融资列表
 *
 * @url /ent_achievements_finance/index
 *
 */

export function entachievementsfinanceindex(params) {
    return axios.post('/ent_achievements_finance/index', params)
}
/**
 * 成果融资列表详
 *
 * @url /ent_achievements_finance/detail
 *
 */

export function entachievementsfinancedetail(params) {
    return axios.post('/ent_achievements_finance/detail', params)
}
/**
 * 成果融资列表增
 *
 * @url /ent_achievements_finance/save
 *
 */

export function entachievementsfinancesave(params) {
    return axios.post('/ent_achievements_finance/save', params)
}
/**
 * 成果融资列表删
 *
 * @url /ent_achievements_finance/delete
 *
 */

export function entachievementsfinancedelete(params) {
    return axios.post('/ent_achievements_finance/delete', params)
}
/**
 * 成果融资列表改
 *
 * @url /ent_achievements_finance/update
 *
 */

export function entachievementsfinanceupdate(params) {
    return axios.post('/ent_achievements_finance/update', params)
}